// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2917":"318711c07ffb85b9","4044":"b8af3d9cdc60ed57","4515":"318711c07ffb85b9","4969":"a6047ef91819ee46","5264":"ae646c00f09ddce7","8378":"a6f489ecd8389e8f"}[chunkId] + ".css";
};